/**
 * Code for MSH Document Listing
 */
import $ from "jquery";

var documentListingContainer = $("#msh-document-listing");

if (documentListingContainer && documentListingContainer.length > 0) {
    $(function () {

        // hide no-data output
        $("#warranty-no-data").hide();
        $("#manufacture-select-wrapper").hide();
        $("#purchase-select-placeholder").hide();
        $("#manufacture-no-data").hide();
        $("#purchase-select-wrapper").hide();
        $("#purchase-select-placeholder").hide();
        $("#purchase-no-data").hide();

        // On tab change, build out new tab content
        documentListingContainer.find("#msh-tabs").on('change.zf.tabs', function () {
            buildTab($(".msh-tabs .tabs-title.is-active"));
        });

        // On filter change, build out new tab content
        $("#documents-dropdown-purchase, #documents-manufacture").change(function () {
            buildTab($(".msh-tabs .tabs-title.is-active"));
        });

        // Determine which tab needs to be set as active in case Foundation Deep Link js does not
        // mark any as active
        const activeTab = $('#msh-tabs li.is-active');
        if (activeTab.length < 1) {
            // if no tab is marked as is-active (i.e., by Foundation Deep Link), make the first tab in the 
            // markup active by simulating the user clicking it
            $('#msh-tabs li:first').trigger("click");
        }

        // On page load get the active tab's data
        buildTab($('#msh-tabs .tabs-title.is-active'));

    });
}

function buildTab(obj) {
    // Init helper vars
    var tabType = $(obj).data("type");
    var $currentTab = $(".tabs-panel[data-type='" + tabType + "']");

    // Build out querystring for ajax request
    var typeParam = "?type=" + tabType;
    var filterParam = (tabType == "homepurchase") ? (($("#documents-dropdown-purchase").val() != "All") ? ("&filter=" + $("#documents-dropdown-purchase").val()) : "") : ($("#documents-manufacture").val() != "All") ? ("&filter=" + $("#documents-manufacture").val()) : "";
    var queryString = typeParam + filterParam;
    var apiUrl = $("#document-listing-apiurl").val();
    $.ajax({
        url: apiUrl + queryString,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            //console.log(data);
            // Figure out which is the current tab
            switch (tabType) {
                case "homepurchase":

                    // Set the "Showing..." label
                    $currentTab.find(".count-purchase").text("Showing " + data.documents.length.toString() + ((data.documents.length == 1) ? " Result" : " Results"));

                    // If initial page load, also get manufacturer categories

                    let optLen = $("#documents-dropdown-purchase").children('option').length;
                    if (optLen <= 1) {
                        $.each(data.envelopes, function (i, value) {
                            var newOption = new Option(value, value, false, false);
                            $("#documents-dropdown-purchase").append(newOption);
                        });
                    }

                    if (data.documents.length > 0) {
                        $("#purchase-select-wrapper").show();
                        $("#purchase-select-placeholder").hide();
                        $("#purchase-no-data").hide();

                        // Add return items
                        buildListItem(data.documents, tabType);
                    }
                    else {
                        $("#purchase-select-placeholder").show();
                        $("#purchase-no-data").show();
                    }
                    break;
                case "warranties":
                    // Set the "Showing..." label
                    $currentTab.find(".count-warranties").text("Showing " + data.warranties.length.toString() + ((data.warranties.length == 1) ? " Result" : " Results"));

                    if (data.warranties.length > 0) {
                        $("#warranty-no-data").hide();

                        // Add return items
                        buildListItem(data.warranties, tabType);
                    }
                    else {
                        $("#warranty-no-data").show();
                    }
                    break;
                case "manufacture":
                    // Set the "Showing..." label
                    $currentTab.find(".count-manufacture").text("Showing " + data.manufacturers.length.toString() + ((data.manufacturers.length == 1) ? " Result" : " Results"));

                    if (data.manufacturers.length > 0) {
                        $("#manufacture-select-wrapper").show();
                        $("#manufacture-select-placeholder").hide();
                        $("#manufacture-no-data").hide();
                        let optLen = $("#documents-manufacture").children('option').length;
                        if (optLen <= 1) {
                            $.each(data.categories, function (i, value) {
                                var newOption = new Option(value, value, false, false);
                                $("#documents-manufacture").append(newOption);
                            });
                        }

                        // Add return items
                        buildListItem(data.manufacturers, tabType);
                    }
                    else {
                        $("#manufacture-select-placeholder").show();
                        $("#manufacture-no-data").show();
                    }
                    break;
            }
        },
        error: function (request, error) {
            console.log("Request: " + JSON.stringify(error));
        }
    });
}

function buildListItem(arr, type) {
    // Wipe out old items from parent wrapper
    switch (type) {
        case "homepurchase":
            $("#document-wrapper .document-list-content").remove();
            break;
        case "warranties":
            $("#warranty-wrapper .document-list-content").remove();
            break;
        case "manufacture":
            $("#manufacture-wrapper .document-list-content").remove();
            break;
    }

    // Build new items
    for (var i = 0; i < arr.length; i++) {
        var filter = (type == "homepurchase") ? arr[i].filter : arr[i].fileCategory;
        var lastModified = '';
        if (arr[i].fileLastModifiedLabel != '' && arr[i].fileLastModifiedLabel != undefined && arr[i].fileLastModifiedLabel != null) {
            lastModified = '<p>Date Added: ' + arr[i].fileLastModifiedLabel + '</p>';
        }

        var template = '<div class="document-list-content">\
                            <p class="pre-lead">' + filter + '</p>\
                            <h3>' + arr[i].fileName + '</h3>\
                            ' + lastModified + '\
                            <a href="' + getFileURL(arr[i].fileDownloadUrl, arr[i].fileName, arr[i].fileType) + '" rel="noopener" target="_blank" class="button show-for-medium">View Document</a>\
                            <a href="' + getFileURL(arr[i].fileDownloadUrl, arr[i].fileName, arr[i].fileType) + '" target="_blank" class="button show-for-small-only">View Document</a>\
                          </div>'

        // Add new item to parent wrapper
        switch (type) {
            case "homepurchase":
                $("#document-wrapper").append(template);
                break;
            case "warranties":
                $("#warranty-wrapper").append(template);
                break;
            case "manufacture":
                $("#manufacture-wrapper").append(template);
                break;
        }
    }
}

function getFileURL(url, fileName, fileType) {
    // Refering to this link https://coderwall.com/p/y347ug/encodeuri-vs-encodeuricomponent
    // We need to encode the pound sign as well since the file name may contain #
    var loadUrl = $("#document-listing-loadurl").val();
    var urlParam = "url=" + url + "&filename=" + encodeURIComponent(fileName) + "&filetype=" + encodeURIComponent(fileType);
    return encodeURI(loadUrl + "?" + urlParam);
}